import React from 'react';
import TrafalgarLogo from './TrafalgarLogo';

const Taskbar = ({ openWindows, minimizedWindows, focusedWindow, onWindowClick, onStartMenuClick, time, date }) => {
  const getWindowTitle = (windowId) => {
    const titles = {
      'about': 'About Trafalgar',
      'oscp': 'OSCP Overview',
      'products': 'Products & Solutions',
      'contact': 'Contact Trafalgar'
    };
    return titles[windowId] || windowId;
  };

  return (
    <div className="taskbar">
      <div 
        className="start-button" 
        onClick={onStartMenuClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onStartMenuClick();
          }
        }}
        tabIndex="0" 
        role="button" 
        aria-label="Start menu"
      >
        <div className="start-logo">
          <TrafalgarLogo />
        </div>
      </div>
      
      <div className="taskbar-items" id="taskbar-items">
        {/* Show open windows */}
        {openWindows.map(windowId => (
          <div
            key={windowId}
            className={`taskbar-item ${focusedWindow === windowId ? 'active' : ''}`}
            onClick={() => onWindowClick(windowId)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onWindowClick(windowId);
              }
            }}
            tabIndex="0"
            role="button"
            aria-label={`Switch to ${getWindowTitle(windowId)}`}
          >
            {getWindowTitle(windowId)}
          </div>
        ))}
        
        {/* Show minimized windows */}
        {minimizedWindows.map(windowId => (
          <div
            key={`minimized-${windowId}`}
            className="taskbar-item minimized"
            onClick={() => onWindowClick(windowId)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onWindowClick(windowId);
              }
            }}
            tabIndex="0"
            role="button"
            aria-label={`Restore ${getWindowTitle(windowId)}`}
          >
            {getWindowTitle(windowId)}
          </div>
        ))}
      </div>
      
      <div className="clock" id="clock">
        <div id="time">{time}</div>
        <div id="date">{date}</div>
      </div>
    </div>
  );
};

export default Taskbar;
